import { MatchResults } from '@/common/constants';
import type { MatchResult } from '@/common/types';

interface GameScoreProps {
  /** Additional CSS class names to apply to the component */
  className?: string;
  /** Final score of the home team */
  homeScore: number;
  /** Final score of the away team */
  awayScore: number;
  /** Match result indicating win/loss/draw */
  result: MatchResult;
}

const backgroundColorClassMap = {
  [MatchResults.WIN]: 'bg-success',
  [MatchResults.LOSS]: 'bg-error',
  [MatchResults.DRAW]: 'bg-pmw-s-base-4-light dark:bg-pmw-s-base-4-dark',
};

const textColorClassMap = {
  [MatchResults.WIN]: 'text-monoY',
  [MatchResults.LOSS]: 'text-monoY',
  [MatchResults.DRAW]: 'text-monoX dark:text-monoY',
};

export default function GameScore({
  className = '',
  homeScore,
  awayScore,
  result,
}: GameScoreProps) {
  const backgroundColorClass = backgroundColorClassMap[result];
  const textColorClass = textColorClassMap[result];

  const scoreClassName = 'font-robotoMedium font-medium text-[12px] leading-[16px]';

  return (
    <div
      className={`flex items-center gap-0.5 py-0.5 px-1 rounded-md ${backgroundColorClass} ${textColorClass} ${className}`}
    >
      <span className={scoreClassName}>{homeScore}</span>
      <span className="font-unibet font-medium text-[15px] leading-[9px] opacity-50">-</span>
      <span className={scoreClassName}>{awayScore}</span>
    </div>
  );
}
